import React from "react";
import styled from "styled-components";
import truncateText from "../../utils/truncateText";

const CartitemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: .5rem .5rem;
 
  border-radius: 8px;
  margin-bottom: 1rem;
  width: 100%;
  margin-top: 5rem;
  
`;

const CartItem = styled.div`
  display: flex;
  justify-content:flex-start;
  align-items: center;
  padding: 0.5rem .4rem;
  
  min-height: 175px;
  border-radius: 8px;
 border: 1px solid #ddd;
  width: 100%;

  @media (max-width: 495px) {
    min-height: 135px;
  }

  
`;
const ImageWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: 100%;
width: auto;

@media (max-width: 495px) {
img{
    width: 119px;
    aspect-ratio: 1;
    object-fit: contain;
    height: unset;

}
}
`
const ItemDetails = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
margin-left: .5rem;
padding-right: .5rem;
font-family: "Ancizar Sans", sans-serif;


.itemprice{
font-family: "Ancizar Sans", sans-serif;
line-height: 1.2;
color:rgb(142, 142, 142);
}

.itempricediscounted{
    font-weight: 500;
    color: rgb(41 132 10);
    font-size: 25px;
    font-family: "Ancizar Sans", sans-serif;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
    .itempricediscounted div:last-child {
    font-size: 14px;
    text-decoration: line-through;
    margin-left: 0.5rem;
    color: #888;
    font-weight: 400;
    }
`

const CartButtonsWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;

.removebutton{
display: flex;
justify-content: center;
align-items: center;

color: #3e3e3e;
width: 111px;
height: 30px;
font-size: 14px;
font-family: "Ancizar Sans", sans-serif;
outline: none;
border: 1px solid #888;
background-color: transparent;

}
.wishlistbutton{
display: flex;
justify-content: center;
align-items: center;
background-color: transparent;

color: #3e3e3e;
width: 111px;
height: 30px;
font-size: 14px;
font-family: "Ancizar Sans", sans-serif;
outline: none;
border: 1px solid #888;
margin-left: .5rem;
}
`

export default function CartitemListMobile({ shipments }) {

    const items = shipments[0]?.cartItemDetails || [];


    

  return (
    <CartitemWrapper>
      {items.map((item, index) => {
        return (
        <CartItem key={index}>
            <ImageWrapper>
                <img src={item?.imageUrl.imageUrl} width={171} height={171} alt = {item.name} />
            </ImageWrapper>
            <ItemDetails>
                <div className="itemprice">
                { truncateText(item?.name, 39)}
                </div>
                <div className="itempricediscounted">
               <div> &#8377;{item.itemPrice.discountedPrice }</div> <div> &#8377;{item.itemPrice.price }</div>
                </div>
               <CartButtonsWrapper>
                <button className="removebutton">remove</button>
                 <button className="wishlistbutton">add to wishlist</button>
               </CartButtonsWrapper>
            
            </ItemDetails>





        </CartItem>
        );
      })}

    </CartitemWrapper>
  );
}
